export enum RelocationEquipmentApiEnum {
  GetRelocationEquipmentAttachmentList = '/relocation-equipments/:relocationEquipmentId/attachments/',
  GetTechnicalExamination = '/relocation-equipments/:relocationEquipmentId/technical-examinations',
  CreateTechnicalExamination = '/relocation-equipments/:relocationEquipmentId/technical-examinations',
}

export enum RelocationEquipmentApiTagEnum {
  RelocationEquipmentAttachmentList = 'RelocationEquipmentAttachmentList',
}
